// @flow
import { cloneElement } from 'react';
import type { Element } from 'react';
import { css } from 'styled-components';
import type { GridLayout } from './Grid';

export type AreaAssignment = { [areaName: string]: Element<any> };

type GridChild = {
  cssIndex: number,
  areaName: string,
  element: Element<any>,
};

export default class NamedGridLayout implements GridLayout {
  gridChildren: Array<GridChild> = [];
  templateSpec: string;
  constructor(templateSpec: string, assignments: AreaAssignment) {
    this.templateSpec = templateSpec;
    // $FlowFixMe - Object.entries is never happy
    for (const [areaName, element]: [string, Node] of Object.entries(assignments)) {
      const gridChild: GridChild = {
        cssIndex: this.gridChildren.length + 1,
        areaName,
        element,
      };
      this.gridChildren.push(gridChild);
    }
  }
  get children(): Iterable<Element<any>> {
    return this.gridChildren.map(({ element, areaName }) =>
      cloneElement(element, { key: areaName }),
    );
  }
  get childRules(): string {
    return css(
      Array(this.gridChildren.length + 1).fill('\n'),
      ...this.gridChildren.map(
        ({ cssIndex, areaName }) => css`
          > *:nth-child(${cssIndex}) {
            grid-area: ${areaName};
          }
        `,
      ),
    );
  }
}
